;(function () {
	function init(root) {
		if (!root || root.dataset.hiwStepsInit === '1') return;
		root.dataset.hiwStepsInit = '1';

		const slides = root.querySelectorAll('[data-hiw-slide]');
		const dots = root.querySelectorAll('[data-hiw-dot]');
		const segments = root.querySelectorAll('[data-hiw-segment]');
		const prev = root.querySelector('[data-hiw-prev]');
		const next = root.querySelector('[data-hiw-next]');

		if (!slides.length) return;

		let index = 0;
		let transitionLock = false;
		const TRANSITION_MS = 620;

		function setDisabled(btn, disabled) {
			if (!btn) return;
			btn.disabled = disabled;
			btn.classList.toggle('is-disabled', disabled);
			btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
		}

		function show(i, opts) {
			const force = opts && opts.force === true;
			const nextIdx = Math.max(0, Math.min(i, slides.length - 1));
			if (!force && nextIdx === index) return;
			if (!force && transitionLock) return;

			if (!force) {
				transitionLock = true;
				window.setTimeout(function () {
					transitionLock = false;
				}, TRANSITION_MS);
			}

			index = nextIdx;

			slides.forEach(function (slide, si) {
				const active = si === index;
				slide.classList.toggle('is-active', active);
				slide.setAttribute('aria-hidden', active ? 'false' : 'true');
				if (active) {
					slide.removeAttribute('inert');
				} else {
					slide.setAttribute('inert', '');
				}
				slide.querySelectorAll('video').forEach(function (videoEl) {
					if (active) {
						return;
					}
					try {
						videoEl.pause();
					} catch (e) {}
				});
			});
			dots.forEach(function (dot, di) {
				const active = di === index;
				const reached = di <= index;
				dot.classList.toggle('is-reached', reached);
				dot.classList.toggle('is-active', active);
				if (active) {
					dot.setAttribute('aria-current', 'step');
				} else {
					dot.removeAttribute('aria-current');
				}
			});
			segments.forEach(function (seg) {
				const si = parseInt(seg.getAttribute('data-hiw-segment'), 10);
				if (Number.isNaN(si)) return;
				seg.classList.toggle('is-reached', index > si);
			});
			setDisabled(prev, index === 0);
			setDisabled(next, index === slides.length - 1);
			if (prev) {
				const onLast = index === slides.length - 1 && index > 0;
				prev.classList.toggle('is-prev-last', onLast);
			}
		}

		show(0, { force: true });

		if (prev) {
			prev.addEventListener('click', function () {
				show(index - 1);
			});
		}
		if (next) {
			next.addEventListener('click', function () {
				show(index + 1);
			});
		}
		dots.forEach(function (dot, di) {
			dot.addEventListener('click', function () {
				show(di);
			});
		});
	}

	function scan(container) {
		(container || document).querySelectorAll('[data-hiw-steps]').forEach(init);
	}

	scan(document);

	document.addEventListener('shopify:section:load', function (e) {
		scan(e.target);
	});
})();
